import { forwardRef, Inject, Injectable, NgZone } from '@angular/core';
import { OauthHelper } from '../webservice'
import { Constants } from '../constants';
import { HttpClient } from './http-client.service';
import { ReportJob } from "../../models";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Store } from "@ngrx/store";
import { ErrorHandlerService } from "../error-handler.service";
import { AppState } from "../../reducers";
import { Logger } from '../logger.service';

const fileSaver = require('../../FileSaver');

@Injectable()
export class ReportingApi {
	private static XHR_FINISHED_STATE = 4;
	private URL = "/api/reporting"
	private reportingBridgeUrl = "/api/reporting-bridge"

	constructor(
		/*
		Not clear why, but using this service in src/app/components/reporting/download-status/download-status.component.ts without forward ref
		causes the application to crash in prod mode.
		 */
		@Inject(forwardRef(() => OauthHelper))private oauthHelper: OauthHelper,
		private ngZone: NgZone,
		private httpClient: HttpClient,
		private errorHandler: ErrorHandlerService,
		private store: Store<AppState>,
		private logger: Logger) {

	}

	public queueReportJob(isBookingOffice: boolean, reportName: string, saveAsFilename: string, queryString: string): Observable<any> {
		return this.httpClient.get(`${this.reportingBridgeUrl}/v1/reports/${isBookingOffice ? 'secondary/' : '' }${reportName}${queryString}`)
			.map(response => <ReportJob>response.json())
			.catch(this.handleError);
	}

	public getReportJobStatus(statusUrl: string): Observable<any> {
		return this.httpClient.get(this.reportingBridgeUrl + statusUrl)
			.catch(this.handleError)
	}

	public fetchReportByJob(fetchUrl: string): Observable<any> {
		return this.httpClient.getFileAsBlob(this.reportingBridgeUrl + fetchUrl)
			.map(response => response.blob())
			.catch(this.handleError)
	}

	public downloadFile(reportName: string, saveAsFilename: string, queryString: string) {
		this.requestReporting("/v1/reports/", reportName, saveAsFilename, queryString);
	}

	public downloadSecondaryReport(reportName: string, saveAsFilename: string, queryString: string) {
		this.requestReporting("/v1/reports/secondary/", reportName, saveAsFilename, queryString);
	}

	private requestReporting(endpoint: string, reportName: string, saveAsFilename: string, queryString: string) {
		let xhr = new XMLHttpRequest();
		xhr.open("GET", ZUUL_BACKEND + this.URL + endpoint + reportName + queryString)
		xhr.responseType = 'blob';
		xhr.setRequestHeader('Authorization', "Bearer " + this.oauthHelper.getAccessToken());
		if (localStorage.getItem(Constants.SESSION_ID) != null) {
			xhr.setRequestHeader(Constants.SESSION_ID_HEADER, localStorage.getItem(Constants.SESSION_ID));
		}
		xhr.onload = (e) => {
			let blob = xhr.response;
			fileSaver.saveAs(blob, saveAsFilename, true);
		}
		xhr.send()
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/reporting-api.service.ts